class ProductRecommendation extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.requestUrl = this.getAttribute("data-url");
    this.fetchRecommendations();
  }
  disconnectedCallback() {}
  async fetchRecommendations() {
    let productRecommendationsSection = this.querySelector(
      ".product-recommendations",
    );

    if (!productRecommendationsSection) {
      productRecommendationsSection = document.createElement('div');
      productRecommendationsSection.className = 'product-recommendations';
      this.appendChild(productRecommendationsSection);
    }

    try {
      const res = await fetch(`${window.Shopify.routes.root}recommendations/products${this.requestUrl}`);
      const text = await res.text();
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (!recommendations || !recommendations.innerHTML.trim()) return;

      const safe = recommendations.cloneNode(true);
      safe.querySelectorAll('product-recommendations').forEach(el => el.remove());

      productRecommendationsSection.innerHTML = safe.innerHTML;

      const glideEl = document.getElementById('productRecommendationGlide');
      if (glideEl && typeof Glide !== 'undefined') {
        if (window.productRecommendationGlideInstance) {
          try { window.productRecommendationGlideInstance.destroy(); } catch (e) { /* ignore */ }
          window.productRecommendationGlideInstance = null;
        }

        window.productRecommendationGlideInstance = new Glide('#productRecommendationGlide', {
          type: 'carousel',
          startAt: 0,
          perView: 4,
          gap: 20,
          breakpoints: {
            1024: { perView: 3, gap: 16 },
            768: { perView: 2, gap: 16 },
            480: { perView: 1, gap: 12 },
          },
        });

        window.productRecommendationGlideInstance.mount();

        // Wire external arrow buttons to Glide API
        const section = this.closest('.product-recommendation-section') || this.parentElement;
        const prevBtn = section && section.querySelector('[data-rec-arrow="prev"]');
        const nextBtn = section && section.querySelector('[data-rec-arrow="next"]');
        if (prevBtn) {
          prevBtn.addEventListener('click', () => window.productRecommendationGlideInstance.go('<'));
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', () => window.productRecommendationGlideInstance.go('>'));
        }
      }
    } catch (err) {
      console.error('Failed to fetch recommendations', err);
    }
  }
}

customElements.define("product-recommendations", ProductRecommendation);
